import {ApolloClient, concat, createHttpLink, from, InMemoryCache, split} from '@apollo/client/core';
import {auth} from '@src/db';
import {appConfig} from '@src/config';
import {setContext} from '@apollo/client/link/context';
import {getMainDefinition} from '@apollo/client/utilities';
import {GraphQLWsLink} from '@apollo/client/link/subscriptions';
import { createClient } from 'graphql-ws';
import {onError} from '@apollo/client/link/error';
const  { RetryLink } = require('@apollo/client/link/retry');
const ApolloLinkTimeout = require('apollo-link-timeout').default;

// HTTP connection to the API
const httpLink = createHttpLink({
  // You should use an absolute URL here
  uri: appConfig.apiUrl+'/graphql',
});
//webSocket connection when a subscription is being called
const wsLink = new GraphQLWsLink(
  createClient({
    url: appConfig.apiWsUrl+'/graphql',
  })
);
//send auth header
const authMiddleware = setContext(operation =>
  auth.currentUser?.getIdTokenResult().then(idToken => {
    return {
      headers: {
        authorization: idToken.token || null,
      },
    };
  })
);

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors)
    graphQLErrors.forEach(({ message, locations, path }) =>
      console.error(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
      )
    );

  if (networkError) console.error(`[Network error]: ${networkError}`);
});

// Timeout padrão das operações HTTP do GraphQL. O timeoutLink fica POR FORA do retryLink
// (ver httpLink2 abaixo), então este valor cobre a cadeia inteira de tentativas — não é por
// retry. Operações pesadas podem sobrescrever por chamada via `context: { timeout: N }`
// (ver FinancialRepositoryGQL.saveTransactions). Subido de 30s → 60s: repasses grandes faziam
// leituras/escritas em massa que estouravam 30s, deixando estado inconsistente ao fechar.
export const GRAPHQL_TIMEOUT_MS = 60000;
const timeoutLink = new ApolloLinkTimeout(GRAPHQL_TIMEOUT_MS);
const retryLink = new RetryLink({
  delay: {
    initial: 300,
    max: Infinity,
    jitter: true
  },
  attempts: {
    max: 3,
    //    retryIf: (error, _operation) => !!error
  }
});

const httpLink2 = timeoutLink.concat(concat(retryLink, concat(authMiddleware, httpLink)));

const link = split(
  // split based on operation type
  ({query}) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
    );
  },
  wsLink,
  httpLink2
);

// Cache implementation
const cache = new InMemoryCache();

// Create the apollo client
export const apolloClient = new ApolloClient({
  link: from([authMiddleware, errorLink, link]),
  cache,
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'ignore',
    },
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    },
  }
  // headers: {
  //   "Authorization": ""
  // }
});
